import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-notifications-profile',
  imports: [ToggleSwitchModule, CommonModule, FormsModule],
  templateUrl: './notifications-profile.component.html',
  styleUrl: './notifications-profile.component.scss'
})
export class NotificationsProfileComponent {
  newsletterChecked: boolean = true;
  newPredictionChecked: boolean = true;
  resultsNotificationChecked: boolean = true;
  promoChecked: boolean = true;

}
